var map = {
	"./DSC_0264.jpg": 1260,
	"./DSC_0268.jpg": 7050,
	"./DSC_0269.jpg": 9382,
	"./DSC_0275.jpg": 7263,
	"./DSC_0278.jpg": 9301,
	"./DSC_0281.jpg": 8817,
	"./DSC_0313.jpg": 8824,
	"./DSC_0317.jpg": 2675,
	"./DSC_0319.jpg": 5503,
	"./DSC_0321.jpg": 7755,
	"./DSC_0325.jpg": 9594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1589;